export default __webpack_public_path__ + "static/media/pala.81ff1ccd.ttf";